import { StorableObject } from "@app/core/storable-object";

export class LastSectionAccessed extends StorableObject {
    public dateTimeOfLastSectionAccess: Date;
    public sectionName: string;
    public sectionUri: string;
}